// extracted by mini-css-extract-plugin
export var typingIndicator = "_on-0";